import React from "react";
import RegistrationFeeDetails from "../forms/RegistrationFeeDetails";

const PrivateCompanyModal = ({paymentRangeList="None"}) => {
  return (
    <div
      className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
      id="exampleModalEdit"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
        <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
          <div className="flex justify-end">
            <svg
              data-bs-dismiss="modal"
              aria-label="Close"
              className="text-primary-blue h-8 w-8"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              role="img"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
              />
            </svg>
          </div>
          <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
            {/* <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        दर्ता शुल्क सम्बन्धि पूर्ण जानकारी 
  </h1> */}

            <div className="border-primary-red m-5 rounded-md border">
              <p className="text-primary-blue text-center border-primary-blue border-b-2 p-3 font-bold md:!text-xl">
                {/* Pvt. Ltd. Company  */}
                <span className="text-primary-red underline ml-2">
                  दर्ता शुल्क सम्बन्धि पूर्ण जानकारी
                </span>
              </p>

              {/* <RegistrationFeeDetails/> */}
              <div className="modal-body relative">
                <div className="border-primary-red m-5 rounded-md border border-b-0">

                  {
                    paymentRangeList.map((item, i)=> {
                      return(
                        <div className="text-primary-blue flex flex-wrap justify-between border-primary-red border-b-2 div-3 font-bold md:!text-xl" key={i}>
                            {/* १००००१ देखि ५ लाख सम्म अधिकृत पुँजी भएमा */}
                          <div className="p-2">
                            
                              {item.range_start} देखि {item.range_end} सम्म अधिकृत पुँजी भएमा
                            </div>
                        <div className="text-primary-red border-primary-red p-2 border-t md:border-t-0 sm:border-l-2 md:w-48 ">&nbsp;{item.amount.split('.')[0]}।–</div>
                      </div>
                      )
                    })
                  }

                  {/* <p className="text-primary-blue border-primary-blue border-b-2 p-3 font-bold md:!text-xl">
                    १००००० लाख सम्म अधिकृत पुँजी भएमा
                    <span className="text-primary-red">रु.१४,५००।–</span>
                  </p>
                  <p className="text-primary-blue border-primary-blue border-b-2 p-3 font-bold md:!text-xl">
                    १००००१ देखि ५ लाख सम्म अधिकृत पुँजी भएमा
                    <span className="text-primary-red">रु.१८,०००।–</span>
                  </p>
                  <p className="text-primary-blue border-primary-blue border-b-2 p-3 font-bold md:!text-xl">
                    ५००००१ देखि २५ लाख सम्म अधिकृत पुँजी भएमा
                    <span className="text-primary-red">रु.२३,५००।–</span>
                  </p>
                  <p className="text-primary-blue border-primary-blue border-b-2 p-3 font-bold md:!text-xl">
                    २५००००१ देखि १ करोड सम्म अधिकृत पुँजी भएमा
                    <span className="text-primary-red"> रु.२९,५००।–</span>
                  </p>
                  <p className="text-primary-blue border-primary-blue border-b-2 p-3 font-bold md:!text-xl">
                    १००००००१ देखि २ करोड सम्म अधिकृत पुँजी भएमा
                    <span className="text-primary-red">रु.३२,५००।–</span>
                  </p> */}
                  {/* <p className="text-primary-blue border-primary-blue border-b-2 p-3 font-bold md:!text-xl">
                    २ करोड भन्दा मथी अधिकृत पुँजी भएमा प्रति १ करोड
                    <span className="text-primary-red">रु.३,०००।– </span>को दरले
                    बृद्धि हुदै जानेछ ।
                  </p> */}
                  {/* <p className="text-primary-blue p-3 font-bold">
                    <span className="text-primary-red"> नोट:</span> माथी
                    उल्लेखित रकम ७ जना सम्म शेयर सदस्यहरु भएमा मात्र लागु हुनेछ,
                    यदि ७ जना भन्दा बढि भएमा प्रती सदस्य
                    <span className="text-primary-red">रु.५००।–</span> को दरले
                    थप शुल्क बृद्धि हुदै जानेछ ।
                  </p> */}
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivateCompanyModal;
